import { getClient } from '@epilot/design-client'
import type {
  DesignId,
  OrganizationId
} from '@epilot/journey-logic-commons/src/types/next'

import { appStore } from '../store'
import { selectJourneyPublicToken } from '../store/selectors/config'
import { configureClient } from '../utils/api-utils'
import { DESIGN_BUILDER_API_BASE_URL } from '../utils/config'

let cachedClient: ReturnType<typeof getClient>

export const getDesignClient = () => {
  if (!cachedClient) {
    const client = getClient()

    cachedClient = configureClient(client, {
      baseURL: DESIGN_BUILDER_API_BASE_URL,
      getToken: async () => {
        // pulls token directly from the currently selected journey settings
        const token = selectJourneyPublicToken(appStore.getState())

        return Promise.resolve(token)
      }
    })
  }

  return cachedClient
}

export const getJourneyDesign = async (
  organizationId: OrganizationId | undefined,
  designId: DesignId | undefined,
  signal?: AbortSignal
) => {
  if (!designId) {
    throw new Error('Expected designId to be set')
  }

  const response = await getDesignClient().getThemeFromDesign(
    {
      designId: designId,
      orgId: organizationId,
      theme: 'NEW'
    },
    undefined,
    { signal }
  )

  return response.data
}
